<script setup lang="ts">
/* eslint-disable max-len */
export interface IconBookmarkProps {
  active?: boolean;
  fill?: string;
}
const props = withDefaults(defineProps<IconBookmarkProps>(), { fill: "#ffffff" });
</script>

<template>
  <svg v-if="props.active" data-test-id="active" width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.186 17.98a.824.824 0 0 1-.586-.255L7 12.061l-5.6 5.696c-.293.318-.814.318-1.14.032a.94.94 0 0 1-.26-.541V.796C0 .35.358 0 .814 0h12.372c.456 0 .814.35.814.796v16.388c-.033.446-.39.796-.814.796z"
      :fill="props.fill"
      fill-rule="evenodd"
    />
  </svg>

  <svg v-else width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.186 17.98a.824.824 0 0 1-.586-.255L7 12.061l-5.6 5.696c-.293.318-.814.318-1.14.032a.94.94 0 0 1-.26-.541V.796C0 .35.358 0 .814 0h12.372c.456 0 .814.35.814.796v16.388c-.033.446-.39.796-.814.796zM7 10.12c.228 0 .423.095.586.254l4.786 4.87V1.59H1.628v13.652l4.786-4.869A.885.885 0 0 1 7 10.12z"
      :fill="props.fill"
      fill-rule="evenodd"
    />
  </svg>
</template>
